import { Category, fetchCategories } from 'common/apiService';
import xIPCountry from 'common/apiService/xIPCountry';
import CategoryList from 'common/CategoryList';
import { __t } from 'common/i18n';
import Layout from 'common/Layout/Layout';
import { Text } from 'common/styles';
import * as Sentry from '@sentry/nextjs';
import Seo from 'common/Seo';
import Breadcrumb from 'common/Breadcrumb';

export default function CategoriesPage({ categories }: { categories: Category[] }) {
  return (
    <Layout>
      <Seo
        title={`${__t('common.categories')} | ${__t('static_siteName')}`}
        description="دسته‌بندی‌های فیلم و سریال فیلمنت برای پیدا کردن سریع محتوای مورد علاقه شما"
        path="/categories"
      />
      <Breadcrumb items={[
        { name: __t('common.home'), url: '/' },
        { name: __t('common.categories'), url: '/categories' },
      ]} />
      <Text variant="h2" as="h1" my={2}>
        {__t('common.categories')}
      </Text>
      <CategoryList items={categories} size="large" />
    </Layout>
  );
}

export async function getServerSideProps({ req, res }) {
  xIPCountry({ req, res });

  try {
    const { data } = await fetchCategories();
    const { items: categories = [] } = data.find(({ type }) => type === 'default') ?? {};

    return {
      props: { categories },
    };
  } catch (err) {
    Sentry.withScope((scope) => {
      scope.setTag('Status', err.response?.status);
      scope.setTag('StatusText', err.response?.statusText);
      scope.setTag('Url', err.response?.config?.url);
      Sentry.captureException(err);
    });

    return { notFound: true };
  }
}
